export default `
  query getStripeSubscriptionInfo ($userId: ID!) {
    getStripeSubscriptionInfo (userId: $userId) {
      success
      message
      payerUserId
      subscriptionDetails {
        subscriptionId
        status
        nextBillingDate
        nextBillingAmount
        price {
          id
          unitAmount
          currency
          productName
        }
        cardDetails {
          lastFour
          brand
        }
        quantity
        cancelAt
      }
      scheduleSubscriptionDetails {
        scheduleId
        status
        phases {
          startDate
          endDate
          items {
            priceId
            quantity
          }
        }
      }
    }
  }
`
